function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 31,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    x: 3,
    y: 6,
    width: 19,
    height: 18,
    rx: 2,
    stroke: props.color,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M28.303 8.65l-5.538 5.384a1 1 0 00.027 1.459l5.538 5c.643.58 1.67.123 1.67-.743V9.367c0-.884-1.063-1.333-1.697-.717z",
    stroke: props.color,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M1 1l27 27",
    stroke: props.color,
    strokeWidth: 1.832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

export default SvgVideoOff;